module.exports = __webpack_public_path__ + "static/media/amex.16b2e64c.svg";